import type { IconLoaders } from "../types";

/** Chevrons and arrows to expand, drill in, sort and navigate */
export const directionIcons = {
    arrow_down: () => import("./arrow_down"),
    arrow_left: () => import("./arrow_left"),
    arrow_right: () => import("./arrow_right"),
    arrow_right_compact: () => import("./arrow_right_compact"),
    arrow_right_small: () => import("./arrow_right_small"),
    arrow_top_right_on_square: () => import("./arrow_top_right_on_square"),
    arrow_up: () => import("./arrow_up"),
    arrow_up_right: () => import("./arrow_up_right"),
    arrow_uturn_left: () => import("./arrow_uturn_left"),
    chevron: () => import("./chevron"),
    chevron_half_right: () => import("./chevron_half_right"),
    chevron_right: () => import("./chevron_right"),
    external_link_small: () => import("./external_link_small"),
} satisfies IconLoaders;
